import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

export default function Quiz(props) {

   const location = useLocation();
   const [id, setId] = useState(props.id ? props.id :new URLSearchParams(location.search).get('id'));
   const [data, setData] = useState([]);
   const [lastClicked , setLastCliked] = useState();
   // const [data , setData] = useState({
   //    '0':{'name': 'Sometext','cover':'card'},
   //    '1':{'name': 'Sometext','cover':'card'},
   //    '2':{'name': 'Sometext','cover':'card'},
   //    '3':{'name': 'Sometext','cover':'card'},
   //    '4':{'name': 'Sometext','cover':'card'},
   //    '5':{'name': 'Sometext','cover':'card'},
   //    '6':{'name': 'Sometext','cover':'card'},
   //    '7':{'name': 'Sometext','cover':'card'},
   //    '8':{'name': 'Sometext','cover':'card'},
   // });
   const [selectedIndex, setSelectedIndex] = useState([]);

  useEffect(()=>{
   getData();
  },[id])

   const getData = () => {
      axios.get("/appi/table/grid/"+id, { withCredentials: true })
      .then(response => {
         console.log(response.data);
         setData(response.data);
      })
      .catch(error => {});
   }


   const handleClick = (index) => {
     setSelectedIndex((prev) =>
       prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
     );
     setLastCliked(index);
   };
   

  return (
    <div style={{width: '100%',minHeight:'100vh',display:'flex'}}>

      <div className='set-container'>
         {
            Array.isArray(data) ?
          data.map( (item, index) => (
                     <div key={index} style={{zIndex:lastClicked === index? 10 : 1, translate:`0px -${(index *2)}px`}}
                     className={`quiz-set-card ${selectedIndex.includes(index) ? "flipped" : ""}`} 
                     onClick={(e) =>handleClick(index) }>
                        <div class="quiz-card-inner">
                           <div class="quiz-card-front">
                              <p className='card-front-txt'>{item.value}</p>
                           </div>
                           <div class="quiz-card-back">
                           <p style={{margin:10, color:'white', fontSize:30}}>{item.answer}</p>
                           </div>
                        </div>
                        
                     </div>
           ))
           : "Empty list"
            
         }
      </div>
    </div>
  )
}
